export type SaleState = {
  saleTerminatedByClerk: boolean;
};

const mutations = {
  SET_SALE_STATE: (state: SaleState, payload: Partial<SaleState>): void => {
    state.saleTerminatedByClerk = payload.saleTerminatedByClerk ?? false;
  },
};
export default mutations;
